<template>
  <div class="basics">
    <el-link class="name" @click="goscheme()" target="_blank">MT区块链基础平台</el-link>
<!--    <div class="name">MT区块链基础平台</div>-->
    <div class="border"></div>
    <div class="lable">拥有自主知识产权的国产高性能安全可靠区块链基础平台</div>
    <div class="content">
      <div class="contents">
        <div class="basicsCT">
          <img src="./../../assets/home/basics1.png" alt="" />
          <div class="lable">
            <p class="name">高性能</p>
            <p class="lables">
              自主设计双层共识机制，实测性能高达10W
              TPS，支撑数千共识节点参与共识，支持数百万用户同时使用系统。自主设计双层共识机制，实测性能高达10W
              TPS，支撑数千共识节点参与共识，支持数百万用户同时使用系统。
            </p>
          </div>
        </div>
        <div class="basicsCT">
          <img src="./../../assets/home/basics3.png" alt="" />
          <div class="lable">
            <p class="name">高可用</p>
            <p class="lables">
              支持高级图灵完备智能合约，以及JSON-RPC行业通用接口的开发，完美支撑企业各场景下私有链联盟链构建。
            </p>
          </div>
        </div>
      </div>
      <div class="contents1">
        <div class="basicsCT">
          <img src="./../../assets/home/basics2.png" alt="" />
          <div class="lable">
            <p class="name">易扩展</p>
            <p class="lables">
              平台组件采用模块化设计，涵盖兼容性和扩展性。通过跨链与多链融合技术，为各种高频的商业应用开发提供基础技术支撑。
            </p>
          </div>
        </div>
        <div class="basicsCT">
          <img src="./../../assets/home/basics4.png" alt="" />
          <div class="lable">
            <p class="name">高安全</p>
            <p class="lables">
              支持国密算法、抗量子攻击算法，保护账户信息安全，支持零知识证明和环签名技术，满足不同应用场景隐私保护需求。
            </p>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="button" @click="goscheme()">查看全部</div>-->
  </div>
</template>

<script>
export default {
  name: "mt-basics",
  data() {
    return {};
  },
  methods: {
    goscheme() {
      this.$router.push({
        name: "scheme",
        query: {
          // item: '基础服务',原先的
          // text: '智信链',原先的
          item: '基础服务',
          text: '兆信链',
          time: new Date().getTime()
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
    .basics{
        max-width: 1280px;
        margin: 50px auto;
        text-align: center;
        .name{
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 900;
            color: #21242A;
            line-height: 45px;
        }
        .border{
            margin: 20px auto;
            width: 27px;
            height: 3px;
            background-color: #056DFF;
        }
        .lable{
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #7c7878;
            line-height: 20px;
            margin-bottom: 50px;
        }
        .content{
            margin: 50px auto 0 auto;
            display: flex;
            width: 100%;
            .contents{
                width: 50%;
                margin-right: 10px;
            }
            .contents1{
                width: 50%;
            }
            .basicsCT{
                background-color: #FFFFFF;
                height: 150px;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                img{
                    width: 72px;
                    height: 87px;
                    margin-left: 35px;
                }
                .lable{
                    text-align: left;
                    padding: 20px;
                    .name{
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-size: 18px;
                        font-weight: 600;
                        color: #282F3C;
                        text-indent:1em
                    }
                    .lables{
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 500;
                        color: #646C7C;
                        line-height: 22px;
                    }
                }
            }
        }
        .button{
            margin: 30px auto 0 auto;
            width: 222px;
            height: 40px;
            line-height: 40px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #E8E8EA;
            color: #646C7C;
            font-weight: 400;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            cursor: pointer;
            &:hover{
                border: 1px solid #0069fd;
            }
        }
    }
</style>
